import API from "service";
import { GET_MY_REFERRALS_ENDPOINT } from "./endpoints";

export const getMyReferralsAPI = (payload) => {
  return API.post(GET_MY_REFERRALS_ENDPOINT, payload);
};
